
export default {
  name: 'notes',
  components: {},
  props: ['respData'],
  data () {
    return {
      responseData:{},
      headers_Notes:[
        {text:"Type", value:"type"},
        {text:"Value", value:"value"},
      ],
    }
  },
  computed: {

  },
  mounted () {
    this.responseData = this.respData;
  },
  methods: {

  }
}


